import { render, staticRenderFns } from "./PictureArea.vue?vue&type=template&id=648cb822&scoped=true"
import script from "./PictureArea.vue?vue&type=script&lang=js"
export * from "./PictureArea.vue?vue&type=script&lang=js"
import style0 from "./PictureArea.vue?vue&type=style&index=0&id=648cb822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648cb822",
  null
  
)

export default component.exports